import { Check, X } from "lucide-react";
import { useT } from "../i18n";

const inputCls = "w-full min-h-[44px] rounded-xl border border-[#0D4045]/15 bg-white px-3.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D4045]/30";

export default function AdminProForm({ form, setForm, meta, onSubmit, onCancel }) {
  const { t } = useT();
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const setNum = (k) => (e) => setForm({ ...form, [k]: e.target.value === "" ? null : parseInt(e.target.value, 10) });

  return (
    <form onSubmit={onSubmit} data-testid="admin-pro-form"
      className="mt-6 bg-white rounded-xl border border-black/5 p-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
      <input data-testid="admin-form-name" required value={form.name} placeholder={t("login.name")}
        onChange={set("name")} className={inputCls} />
      <select data-testid="admin-form-specialty" value={form.specialty} onChange={set("specialty")} className={inputCls}>
        {meta.specialties.map((s) => <option key={s} value={s}>{t(`specialty.${s}`)}</option>)}
      </select>
      <select data-testid="admin-form-commune" value={form.commune} onChange={set("commune")} className={inputCls}>
        {meta.communes.map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
      <select data-testid="admin-form-status" value={form.status} onChange={set("status")} className={inputCls}>
        {["disponible", "liste_attente", "complet"].map((s) => <option key={s} value={s}>{t(`status.${s}`)}</option>)}
      </select>
      <input data-testid="admin-form-phone" value={form.phone} placeholder={t("login.phone")}
        onChange={set("phone")} className={inputCls} />
      <input data-testid="admin-form-email" type="email" value={form.contact_email} placeholder={t("login.email")}
        onChange={set("contact_email")} className={inputCls} />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:col-span-2">
        <input data-testid="admin-form-places-available" type="number" min="0"
          value={form.places_available ?? ""} placeholder={t("pro.places")}
          onChange={setNum("places_available")} className={inputCls} />
        <input data-testid="admin-form-places-total" type="number" min="0"
          value={form.places_total ?? ""} placeholder={t("pro.places.total")}
          onChange={setNum("places_total")} className={inputCls} />
        <input data-testid="admin-form-wait" value={form.wait_estimate}
          placeholder={t("pro.wait")} onChange={set("wait_estimate")} className={inputCls} />
      </div>
      <textarea data-testid="admin-form-note" rows={2} value={form.note} placeholder={t("pro.profile.note")}
        onChange={set("note")}
        className="sm:col-span-2 w-full rounded-xl border border-[#0D4045]/15 bg-white px-3.5 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D4045]/30" />
      <div className="flex flex-wrap gap-6">
        <label className="flex items-center gap-2 text-sm font-semibold text-[#0D4045]">
          <input type="checkbox" data-testid="admin-form-approved" className="accent-[#0D4045]"
            checked={form.approved} onChange={(e) => setForm({ ...form, approved: e.target.checked })} />
          {t("admin.approve")}
        </label>
        <label className="flex items-center gap-2 text-sm font-semibold text-[#0D4045]">
          <input type="checkbox" data-testid="admin-form-consent" className="accent-[#0D4045]"
            checked={form.consent} onChange={(e) => setForm({ ...form, consent: e.target.checked })} />
          {t("admin.consent")}
        </label>
      </div>
      <div className="flex gap-2 sm:justify-end">
        <button type="button" data-testid="admin-form-cancel" onClick={onCancel}
          className="flex items-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-semibold text-[#6B7280] hover:bg-black/5 transition-colors duration-200">
          <X size={15} /> {t("filters.clear")}
        </button>
        <button type="submit" data-testid="admin-form-save"
          className="flex items-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-semibold bg-[#0D4045] text-[#FDFBF7] hover:bg-[#0a3237] transition-colors duration-200">
          <Check size={15} /> {t("admin.save")}
        </button>
      </div>
    </form>
  );
}
